import React, { useEffect, useState } from 'react';
import { DatePicker, Switch } from 'antd';
import Select from 'components/Select';
import { ToastError, ToastSuccess } from 'components/Toaster';
import dayjs from 'dayjs';
import Colors from 'enums/Colors';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { IoReload } from 'react-icons/io5';
import styled from 'styled-components';
import { FadCoursesModel } from 'models/ferramentaAutoria/FadCoursesModel';
import { FadCommentaryContentService } from 'core/http/service/ferramentaAutoria/FadCommentaryContent.service';

export interface ParmsReportCommentary {
    subCommentarys: boolean;
    dateInicio?: string | null;
    dateFim?: string | null;
    allClasses?: boolean;
}

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1100px;
        min-height: 320px;
        background-color: #ffffff;
        padding: 40px;
        gap: 2rem;
        margin-bottom: 200px;

        -webkit-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        -moz-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
    `,

    Title: styled.h1`
        font-size: 26px;
        font-weight: 700;
        color: ${Colors.Blue};
        text-decoration: underline;
        text-underline-offset: calc(1rem);
    `,

    Content: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 1rem;
        gap: 2rem;
        margin-top: 30px;
    `,

    SubTitle: styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${Colors.Blue};
        margin-bottom: 10px;
    `,
};

interface ICardReportCommentaryFAD {
    cursoFad: FadCoursesModel[];
}

const service = new FadCommentaryContentService();

const CardReportCommentaryFAD = ({ cursoFad }: ICardReportCommentaryFAD) => {
    const [loadingSubmit, setLoadingSubmit] = useState<number>(-1);
    const [coursesFad, setCourseSelected] = useState<any>(-1);
    const [dataPeriodo, setDataPeriodo] = useState<string[]>([]);
    const [subCommentary, setSubCommentary] = useState<boolean>(false);
    const [allClasses, setAllClasses] = useState<boolean>(true);

    function cleanParams(params: Record<string, any>) {
        return Object.fromEntries(
            Object.entries(params).filter(([_, value]) => {
                return value !== undefined && value !== null && value !== '';
            })
        );
    }

    const handleRelatorioFad = async () => {
        if (!coursesFad) {
            return ToastError('Nenhuma solução selecionada!');
        }

        setLoadingSubmit(1);

        try {
            const rawBody: ParmsReportCommentary = {
                subCommentarys: subCommentary,
                dateInicio: dataPeriodo.length > 0 ? dataPeriodo[0] : null,
                dateFim: dataPeriodo.length > 0 ? dataPeriodo[1] : null,
                allClasses: allClasses,
            };

            const body = cleanParams(rawBody);

            const { status } = await service.handleRelatorio(coursesFad, body);

            if (status === 200) {
                ToastSuccess('Gerando relátorio, aguarde alguns minutos.');
            }
        } catch (error) {
            ToastError('Ocorreu algum erro no servidor!');
            console.log('🚀 ~ handleRelatorioFad ~ error:', error);
        }
        setLoadingSubmit(-1);
    };

    const clearFilter = () => {
        setDataPeriodo([]);
        setCourseSelected(null);
    };

    return (
        <Styled.Container>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Styled.Title>FERRAMENTA DE AUTORIA - COMENTÁRIOS</Styled.Title>
                <div
                    onClick={clearFilter}
                    style={{
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <IoReload size={24} />
                    Limpar filtro
                </div>
            </div>
            <Styled.Content>
                <div>
                    <Styled.SubTitle>Curso</Styled.SubTitle>
                    <Select
                        style={{ width: '200px' }}
                        placeholder="Selecione"
                        onSelected={value => setCourseSelected(value.value)}
                        itens={cursoFad.map((dados: any) => ({
                            value: dados.codigo,
                            label: dados.codigo + ' - ' + dados.name,
                        }))}
                    />
                </div>

                <div>
                    <Styled.SubTitle>Período</Styled.SubTitle>
                    <DatePicker.RangePicker
                        size="large"
                        style={{
                            height: 50,
                        }}
                        value={dataPeriodo.length === 2 ? [dayjs(dataPeriodo[0]), dayjs(dataPeriodo[1])] : null}
                        placeholder={['Início', 'Término']}
                        allowEmpty={[false, false]}
                        onChange={(date, dateString) => {
                            setDataPeriodo(dateString);
                        }}
                    />
                </div>
                <div>
                    <Styled.SubTitle>Adicionar as respostas dos usuários</Styled.SubTitle>
                    <Switch style={{ marginTop: 16 }} value={subCommentary} onChange={c => setSubCommentary(c)} />
                </div>

                <div>
                    <Styled.SubTitle>Incluir todas as turmas</Styled.SubTitle>
                    <Switch defaultChecked checked={allClasses} onChange={setAllClasses} />
                </div>
            </Styled.Content>
            <ButtonHomeV2
                disabled={loadingSubmit === 1}
                style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => {
                    loadingSubmit === -1 && handleRelatorioFad();
                }}
            >
                {loadingSubmit === 1 ? <div className="loaderCreater" /> : 'Gerar relatório'}
            </ButtonHomeV2>
        </Styled.Container>
    );
};

export default CardReportCommentaryFAD;
